import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Users, Clock } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import GamePill from './GamePill';

export default function EventCard({ event, index = 0 }) {
  const navigate = useNavigate();

  const defaultImage = 'https://images.unsplash.com/photo-1547638375-ebf04735d792?w=400&h=200&fit=crop';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.1 }}
      className="event-card cursor-pointer"
      onClick={() => navigate(`/events/${event.id}`)}
      data-testid={`event-card-${event.id}`}
    >
      <div className="relative h-32 overflow-hidden">
        <img
          src={event.image || defaultImage}
          alt={event.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F16] to-transparent"></div>
        <div className="absolute top-3 left-3">
          <GamePill game={event.game_type} small />
        </div>
      </div>

      <div className="p-4">
        <h3 className="font-semibold text-white text-base mb-2 line-clamp-1" style={{ fontFamily: 'Unbounded, sans-serif' }}>
          {event.title}
        </h3>

        <div className="flex items-center gap-4 text-[#A1A1AA] text-sm mb-3">
          <div className="flex items-center gap-1.5">
            <Clock size={14} weight="duotone" className="text-[#00F0FF]" />
            <span>{event.date} · {event.time}</span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-[#A1A1AA] text-sm">
            <MapPin size={14} weight="duotone" className="text-[#9D4CDD]" />
            <span className="line-clamp-1">{event.location}</span>
          </div>
          
          <div className="flex items-center gap-1.5">
            <Users size={14} weight="duotone" className="text-[#39FF14]" />
            <span className="text-sm font-medium text-white">
              {event.current_players}/{event.max_players}
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
